module.exports = __webpack_public_path__ + "media/signup-react/star-45539cd9.png";